import React from "react";
import DigitalMarketingHeading from "../customComponent/DigitalMarketingHeading";
import DigitalGrowthSection from "../customComponent/DigitalGrowthSection";
import CoreServicesSection from "../customComponent/CoreServicesSection";
import WhyChooseGlowTech from "../customComponent/WhyChooseGlowTech";
import ResultsMetrics from "../customComponent/ResultsMetrics"
import DigitalMarketingBenefits from "../customComponent/DigitalMarketingBenefits ";

const ServicesPage = () => {
  const metrics = [
    {
      value: "200+",
      label: "Successful Campaigns",
    },
    {
      value: "300%",
      label: "Increase in Organic Traffic",
    },
    {
      value: "10x",
      label: "Lead Generation through PPC",
    },
    {
      value: "50%",
      label: "Boost in Brand Engagement",
    },
  ];
  return (
    <>
      <DigitalMarketingHeading />
      <DigitalGrowthSection />
      <CoreServicesSection />
      <WhyChooseGlowTech />
      <ResultsMetrics  title={"Results That Speak"} metrics={metrics}/>
      <DigitalMarketingBenefits />
    </>
  );
};

export default ServicesPage;
